import { render, staticRenderFns } from "./PopupVipTips.vue?vue&type=template&id=cbd0edfa&scoped=true&"
import script from "./PopupVipTips.vue?vue&type=script&lang=js&"
export * from "./PopupVipTips.vue?vue&type=script&lang=js&"
import style0 from "./PopupVipTips.vue?vue&type=style&index=0&id=cbd0edfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd0edfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbd0edfa')) {
      api.createRecord('cbd0edfa', component.options)
    } else {
      api.reload('cbd0edfa', component.options)
    }
    module.hot.accept("./PopupVipTips.vue?vue&type=template&id=cbd0edfa&scoped=true&", function () {
      api.rerender('cbd0edfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vip/comp/PopupVipTips.vue"
export default component.exports